// Action Types
export const blogActions = {
  FETCH_BLOGS_REQUEST: 'FETCH_BLOGS_REQUEST',
  FETCH_BLOGS_SUCCESS: 'FETCH_BLOGS_SUCCESS',
  FETCH_BLOGS_FAILURE: 'FETCH_BLOGS_FAILURE',

  UPLOAD_IMAGE_REQUEST: 'UPLOAD_IMAGE_REQUEST',
  UPLOAD_IMAGE_SUCCESS: 'UPLOAD_IMAGE_SUCCESS',
  UPLOAD_IMAGE_FAILURE: 'UPLOAD_IMAGE_FAILURE',

  REMOVE_IMAGE_REQUEST: 'REMOVE_IMAGE_REQUEST',
  REMOVE_IMAGE_SUCCESS: 'REMOVE_IMAGE_SUCCESS',
  REMOVE_IMAGE_FAILURE: 'REMOVE_IMAGE_FAILURE',

  SAVE_BLOG_REQUEST: 'SAVE_BLOG_REQUEST',
  SAVE_BLOG_SUCCESS: 'SAVE_BLOG_SUCCESS',
  SAVE_BLOG_FAILURE: 'SAVE_BLOG_FAILURE',

  FETCH_BLOG_REQUEST_BYID: "FETCH_BLOG_REQUEST_BYID",
  FETCH_BLOG_SUCCESS_BYID: "FETCH_BLOG_SUCCESS_BYID",
  FETCH_BLOG_FAILURE_BYID: "FETCH_BLOG_FAILURE_BYID",

  DELETE_BLOG_REQUEST: "DELETE_BLOG_REQUEST",
  DELETE_BLOG_SUCCESS: "DELETE_BLOG_SUCCESS",
  DELETE_BLOG_FAILURE: "DELETE_BLOG_FAILURE",


};

// Action Creators
export const fetchBlogsRequest = (page) => ({
  type: blogActions.FETCH_BLOGS_REQUEST,
  payload: page,
});

export const fetchBlogsSuccess = (blogs, hasMore, currentPage) => ({
  type: blogActions.FETCH_BLOGS_SUCCESS,
  payload: { blogs, hasMore, currentPage },
});

export const fetchBlogsFailure = (error) => ({
  type: blogActions.FETCH_BLOGS_FAILURE,
  payload: error,
});

export const uploadImageRequest = (formData, callback) => ({
  type: blogActions.UPLOAD_IMAGE_REQUEST,
  payload: {formData, callback},
});

export const uploadImageSuccess = (image) => ({
  type: blogActions.UPLOAD_IMAGE_SUCCESS,
  payload: image,
});

export const uploadImageFailure = (error) => ({
  type: blogActions.UPLOAD_IMAGE_FAILURE,
  payload: error,
});

export const removeImageRequest = (imageId) => ({
  type: blogActions.REMOVE_IMAGE_REQUEST,
  payload: imageId,
});

export const removeImageSuccess = (imageUrls) => ({
  type: blogActions.REMOVE_IMAGE_SUCCESS,
  payload: imageUrls,
});

export const removeImageFailure = (error) => ({
  type: blogActions.REMOVE_IMAGE_FAILURE,
  payload: error,
});

// export const saveBlogRequest = (blogData) => ({
//   type: blogActions.SAVE_BLOG_REQUEST,
//   payload: blogData,
// });

export const saveBlogRequest = (formData, callback) => ({
  type: "SAVE_BLOG_REQUEST",
  payload: { formData, callback },
});

export const saveBlogSuccess = () => ({
  type: blogActions.SAVE_BLOG_SUCCESS,
});

export const saveBlogFailure = (error) => ({
  type: blogActions.SAVE_BLOG_FAILURE,
  payload: error,
});

export const fetchBlogRequestById = (id, callback) => ({
  type: blogActions.FETCH_BLOG_REQUEST_BYID,
  payload: { id },
  callback, // Optional callback to handle the fetched blog data
});

// Action creator for delete request
export const deleteBlogRequest = (blogId) => ({
  type: blogActions.DELETE_BLOG_REQUEST,
  payload: blogId,
});

// Action creator for successful delete
export const deleteBlogSuccess = (blogId) => ({
  type: blogActions.DELETE_BLOG_SUCCESS,
  payload: blogId,
});

// Action creator for failed delete
export const deleteBlogFailure = (error) => ({
  type: blogActions.DELETE_BLOG_FAILURE,
  payload: error,
});